/*
 *
 * ResultPopUp
 *
 * @version 1.0.0
 * @author Marco Civello
 * @since 23-Jan-2025
 */

const formattedMessage = {}
export default formattedMessage

export const messages = {
  close: {
    id: 't.app.project.btn.close',
    defaultMessage: 'Close'
  },
  closeLabel: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  },
  successTitle: {
    id: 't.app.orders.operation.popup.successMessage',
    defaultMessage: 'The operation was successfully completed.'
  },
  failedTitle: {
    id: 't.app.orders.operation.popup.failedMessage',
    defaultMessage: 'The operation failed.'
  },
  warningTitle: {
    id: 't.app.paybylink.wizard.advancedSettings.contractAndSubscription.popup.title',
    defaultMessage: 'Warning!'
  },
  successIconAriaLabel: {
    id: 't.app.project.popup.default.title.success',
    defaultMessage: 'Done!'
  },
  errorIconAriaLabel: {
    id: 't.app.project.popup.default.title.failure',
    defaultMessage: 'Failed!'
  },
}